import { useCreatePlaybookMutation } from "../redux/slices/playbook-api";
import { CreatePlaybookPayload } from "../redux/slices/playbook-api/types";

interface createPlaybookWithDefaultsProps {
  name: string;
  playIds: string[];
  tags: any;
}

export const useCreatePlaybook = () => {
  const [createPlaybook] = useCreatePlaybookMutation();

  const createPlaybookWithDefaults = async ({ name, playIds, tags }: createPlaybookWithDefaultsProps) => {
    const playbookSkeleton: CreatePlaybookPayload = {
      chapters: [
        {
          title: "",
          sections: [
            {
              name: "",
              plays: playIds,
            },
          ],
        },
      ],
      title: name,
      tags: tags
    };

    return await createPlaybook(playbookSkeleton).unwrap();
  };

  return {
    createPlaybookWithDefaults,
  };
};
